"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mark = exports.Result = exports.Vote = exports.Oracle = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../google/protobuf/duration");
exports.protobufPackage = "Switcheo.carbon.oracle";
const baseParams = {
    oracleSlashEnabled: false,
    oracleSlashWindowBlock: 0,
    oracleSlashInitial: "",
    oracleSlashIncrement: "",
    oracleContinuousSlashMax: 0,
    newlyBondedWindowAllowance: 0,
    oracleMinVoteFactor: "",
    maxPowerToSlashFactor: "",
};
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleSlashEnabled === true) {
            writer.uint32(8).bool(message.oracleSlashEnabled);
        }
        if (message.oracleSlashWindowBlock !== 0) {
            writer.uint32(16).uint32(message.oracleSlashWindowBlock);
        }
        if (message.oracleSlashInitial !== "") {
            writer.uint32(26).string(message.oracleSlashInitial);
        }
        if (message.oracleSlashIncrement !== "") {
            writer.uint32(34).string(message.oracleSlashIncrement);
        }
        if (message.oracleContinuousSlashMax !== 0) {
            writer.uint32(40).uint32(message.oracleContinuousSlashMax);
        }
        if (message.newlyBondedWindowAllowance !== 0) {
            writer.uint32(48).uint32(message.newlyBondedWindowAllowance);
        }
        if (message.voteTimestampFutureAllowance !== undefined) {
            duration_1.Duration.encode(message.voteTimestampFutureAllowance, writer.uint32(58).fork()).ldelim();
        }
        if (message.oracleMinVoteFactor !== "") {
            writer.uint32(66).string(message.oracleMinVoteFactor);
        }
        if (message.maxPowerToSlashFactor !== "") {
            writer.uint32(74).string(message.maxPowerToSlashFactor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleSlashEnabled = reader.bool();
                    break;
                case 2:
                    message.oracleSlashWindowBlock = reader.uint32();
                    break;
                case 3:
                    message.oracleSlashInitial = reader.string();
                    break;
                case 4:
                    message.oracleSlashIncrement = reader.string();
                    break;
                case 5:
                    message.oracleContinuousSlashMax = reader.uint32();
                    break;
                case 6:
                    message.newlyBondedWindowAllowance = reader.uint32();
                    break;
                case 7:
                    message.voteTimestampFutureAllowance = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.oracleMinVoteFactor = reader.string();
                    break;
                case 9:
                    message.maxPowerToSlashFactor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParams);
        message.oracleSlashEnabled =
            object.oracleSlashEnabled !== undefined &&
                object.oracleSlashEnabled !== null
                ? Boolean(object.oracleSlashEnabled)
                : false;
        message.oracleSlashWindowBlock =
            object.oracleSlashWindowBlock !== undefined &&
                object.oracleSlashWindowBlock !== null
                ? Number(object.oracleSlashWindowBlock)
                : 0;
        message.oracleSlashInitial =
            object.oracleSlashInitial !== undefined &&
                object.oracleSlashInitial !== null
                ? String(object.oracleSlashInitial)
                : "";
        message.oracleSlashIncrement =
            object.oracleSlashIncrement !== undefined &&
                object.oracleSlashIncrement !== null
                ? String(object.oracleSlashIncrement)
                : "";
        message.oracleContinuousSlashMax =
            object.oracleContinuousSlashMax !== undefined &&
                object.oracleContinuousSlashMax !== null
                ? Number(object.oracleContinuousSlashMax)
                : 0;
        message.newlyBondedWindowAllowance =
            object.newlyBondedWindowAllowance !== undefined &&
                object.newlyBondedWindowAllowance !== null
                ? Number(object.newlyBondedWindowAllowance)
                : 0;
        message.voteTimestampFutureAllowance =
            object.voteTimestampFutureAllowance !== undefined &&
                object.voteTimestampFutureAllowance !== null
                ? duration_1.Duration.fromJSON(object.voteTimestampFutureAllowance)
                : undefined;
        message.oracleMinVoteFactor =
            object.oracleMinVoteFactor !== undefined &&
                object.oracleMinVoteFactor !== null
                ? String(object.oracleMinVoteFactor)
                : "";
        message.maxPowerToSlashFactor =
            object.maxPowerToSlashFactor !== undefined &&
                object.maxPowerToSlashFactor !== null
                ? String(object.maxPowerToSlashFactor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleSlashEnabled !== undefined &&
            (obj.oracleSlashEnabled = message.oracleSlashEnabled);
        message.oracleSlashWindowBlock !== undefined &&
            (obj.oracleSlashWindowBlock = message.oracleSlashWindowBlock);
        message.oracleSlashInitial !== undefined &&
            (obj.oracleSlashInitial = message.oracleSlashInitial);
        message.oracleSlashIncrement !== undefined &&
            (obj.oracleSlashIncrement = message.oracleSlashIncrement);
        message.oracleContinuousSlashMax !== undefined &&
            (obj.oracleContinuousSlashMax = message.oracleContinuousSlashMax);
        message.newlyBondedWindowAllowance !== undefined &&
            (obj.newlyBondedWindowAllowance = message.newlyBondedWindowAllowance);
        message.voteTimestampFutureAllowance !== undefined &&
            (obj.voteTimestampFutureAllowance = message.voteTimestampFutureAllowance
                ? duration_1.Duration.toJSON(message.voteTimestampFutureAllowance)
                : undefined);
        message.oracleMinVoteFactor !== undefined &&
            (obj.oracleMinVoteFactor = message.oracleMinVoteFactor);
        message.maxPowerToSlashFactor !== undefined &&
            (obj.maxPowerToSlashFactor = message.maxPowerToSlashFactor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseParams);
        message.oracleSlashEnabled = (_a = object.oracleSlashEnabled) !== null && _a !== void 0 ? _a : false;
        message.oracleSlashWindowBlock = (_b = object.oracleSlashWindowBlock) !== null && _b !== void 0 ? _b : 0;
        message.oracleSlashInitial = (_c = object.oracleSlashInitial) !== null && _c !== void 0 ? _c : "";
        message.oracleSlashIncrement = (_d = object.oracleSlashIncrement) !== null && _d !== void 0 ? _d : "";
        message.oracleContinuousSlashMax = (_e = object.oracleContinuousSlashMax) !== null && _e !== void 0 ? _e : 0;
        message.newlyBondedWindowAllowance = (_f = object.newlyBondedWindowAllowance) !== null && _f !== void 0 ? _f : 0;
        message.voteTimestampFutureAllowance =
            object.voteTimestampFutureAllowance !== undefined &&
                object.voteTimestampFutureAllowance !== null
                ? duration_1.Duration.fromPartial(object.voteTimestampFutureAllowance)
                : undefined;
        message.oracleMinVoteFactor = (_g = object.oracleMinVoteFactor) !== null && _g !== void 0 ? _g : "";
        message.maxPowerToSlashFactor = (_h = object.maxPowerToSlashFactor) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
const baseOracle = {
    creator: "",
    id: "",
    description: "",
    status: "",
    minTurnoutPercentage: long_1.default.ZERO,
    maxResultAge: long_1.default.ZERO,
    securityType: "",
    resultStrategy: "",
    resolution: long_1.default.ZERO,
    spec: "",
};
exports.Oracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (message.status !== "") {
            writer.uint32(34).string(message.status);
        }
        if (!message.minTurnoutPercentage.isZero()) {
            writer.uint32(40).int64(message.minTurnoutPercentage);
        }
        if (!message.maxResultAge.isZero()) {
            writer.uint32(48).int64(message.maxResultAge);
        }
        if (message.securityType !== "") {
            writer.uint32(58).string(message.securityType);
        }
        if (message.resultStrategy !== "") {
            writer.uint32(66).string(message.resultStrategy);
        }
        if (!message.resolution.isZero()) {
            writer.uint32(72).int64(message.resolution);
        }
        if (message.spec !== "") {
            writer.uint32(82).string(message.spec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                case 3:
                    message.description = reader.string();
                    break;
                case 4:
                    message.status = reader.string();
                    break;
                case 5:
                    message.minTurnoutPercentage = reader.int64();
                    break;
                case 6:
                    message.maxResultAge = reader.int64();
                    break;
                case 7:
                    message.securityType = reader.string();
                    break;
                case 8:
                    message.resultStrategy = reader.string();
                    break;
                case 9:
                    message.resolution = reader.int64();
                    break;
                case 10:
                    message.spec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseOracle);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.description =
            object.description !== undefined && object.description !== null
                ? String(object.description)
                : "";
        message.status =
            object.status !== undefined && object.status !== null
                ? String(object.status)
                : "";
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromString(object.minTurnoutPercentage)
                : long_1.default.ZERO;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromString(object.maxResultAge)
                : long_1.default.ZERO;
        message.securityType =
            object.securityType !== undefined && object.securityType !== null
                ? String(object.securityType)
                : "";
        message.resultStrategy =
            object.resultStrategy !== undefined && object.resultStrategy !== null
                ? String(object.resultStrategy)
                : "";
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromString(object.resolution)
                : long_1.default.ZERO;
        message.spec =
            object.spec !== undefined && object.spec !== null
                ? String(object.spec)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined && (obj.id = message.id);
        message.description !== undefined &&
            (obj.description = message.description);
        message.status !== undefined && (obj.status = message.status);
        message.minTurnoutPercentage !== undefined &&
            (obj.minTurnoutPercentage = (message.minTurnoutPercentage || long_1.default.ZERO).toString());
        message.maxResultAge !== undefined &&
            (obj.maxResultAge = (message.maxResultAge || long_1.default.ZERO).toString());
        message.securityType !== undefined &&
            (obj.securityType = message.securityType);
        message.resultStrategy !== undefined &&
            (obj.resultStrategy = message.resultStrategy);
        message.resolution !== undefined &&
            (obj.resolution = (message.resolution || long_1.default.ZERO).toString());
        message.spec !== undefined && (obj.spec = message.spec);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseOracle);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        message.description = (_c = object.description) !== null && _c !== void 0 ? _c : "";
        message.status = (_d = object.status) !== null && _d !== void 0 ? _d : "";
        message.minTurnoutPercentage =
            object.minTurnoutPercentage !== undefined &&
                object.minTurnoutPercentage !== null
                ? long_1.default.fromValue(object.minTurnoutPercentage)
                : long_1.default.ZERO;
        message.maxResultAge =
            object.maxResultAge !== undefined && object.maxResultAge !== null
                ? long_1.default.fromValue(object.maxResultAge)
                : long_1.default.ZERO;
        message.securityType = (_e = object.securityType) !== null && _e !== void 0 ? _e : "";
        message.resultStrategy = (_f = object.resultStrategy) !== null && _f !== void 0 ? _f : "";
        message.resolution =
            object.resolution !== undefined && object.resolution !== null
                ? long_1.default.fromValue(object.resolution)
                : long_1.default.ZERO;
        message.spec = (_g = object.spec) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
const baseVote = {
    oracleId: "",
    timestamp: long_1.default.ZERO,
    data: "",
    voter: "",
};
exports.Vote = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleId !== "") {
            writer.uint32(10).string(message.oracleId);
        }
        if (!message.timestamp.isZero()) {
            writer.uint32(16).int64(message.timestamp);
        }
        if (message.data !== "") {
            writer.uint32(26).string(message.data);
        }
        if (message.voter !== "") {
            writer.uint32(34).string(message.voter);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseVote);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleId = reader.string();
                    break;
                case 2:
                    message.timestamp = reader.int64();
                    break;
                case 3:
                    message.data = reader.string();
                    break;
                case 4:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseVote);
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromString(object.timestamp)
                : long_1.default.ZERO;
        message.data =
            object.data !== undefined && object.data !== null
                ? String(object.data)
                : "";
        message.voter =
            object.voter !== undefined && object.voter !== null
                ? String(object.voter)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.timestamp !== undefined &&
            (obj.timestamp = (message.timestamp || long_1.default.ZERO).toString());
        message.data !== undefined && (obj.data = message.data);
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseVote);
        message.oracleId = (_a = object.oracleId) !== null && _a !== void 0 ? _a : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromValue(object.timestamp)
                : long_1.default.ZERO;
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : "";
        message.voter = (_c = object.voter) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseResult = { oracleId: "", timestamp: long_1.default.ZERO, data: "" };
exports.Result = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleId !== "") {
            writer.uint32(10).string(message.oracleId);
        }
        if (!message.timestamp.isZero()) {
            writer.uint32(24).int64(message.timestamp);
        }
        if (message.data !== "") {
            writer.uint32(34).string(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseResult);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleId = reader.string();
                    break;
                case 3:
                    message.timestamp = reader.int64();
                    break;
                case 4:
                    message.data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseResult);
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromString(object.timestamp)
                : long_1.default.ZERO;
        message.data =
            object.data !== undefined && object.data !== null
                ? String(object.data)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.timestamp !== undefined &&
            (obj.timestamp = (message.timestamp || long_1.default.ZERO).toString());
        message.data !== undefined && (obj.data = message.data);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseResult);
        message.oracleId = (_a = object.oracleId) !== null && _a !== void 0 ? _a : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromValue(object.timestamp)
                : long_1.default.ZERO;
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMark = { oracleId: "", timestamp: long_1.default.ZERO };
exports.Mark = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.oracleId !== "") {
            writer.uint32(10).string(message.oracleId);
        }
        if (!message.timestamp.isZero()) {
            writer.uint32(16).int64(message.timestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMark);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.oracleId = reader.string();
                    break;
                case 2:
                    message.timestamp = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMark);
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromString(object.timestamp)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        message.timestamp !== undefined &&
            (obj.timestamp = (message.timestamp || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMark);
        message.oracleId = (_a = object.oracleId) !== null && _a !== void 0 ? _a : "";
        message.timestamp =
            object.timestamp !== undefined && object.timestamp !== null
                ? long_1.default.fromValue(object.timestamp)
                : long_1.default.ZERO;
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
